import PropTypes              from 'prop-types'
import React                  from 'react'
import { withRouter         } from 'react-router'
import { Alert, FormControl } from 'react-bootstrap'

import { ForbiddenError                   } from 'lib/errors'
import { Panel, Recaptcha, HorizontalForm } from 'alto-react-components/lib/components'

import { sessionSetting, recaptchaSetting, emailAsUsernameSetting } \
  from 'alto-react-base-auth/lib/settings'

import { InitPasswordResetLink, ResendActivationEmailLink } \
  from 'alto-react-base-auth/lib/routes'

class Login extends React.Component
  @contextTypes =
    auth:     PropTypes.object
    settings: PropTypes.object

  constructor: (props, context) ->
    super(props, context)

    recaptcha = recaptchaSetting(context.settings)

    @state =
      error:           null
      username:        ''
      password:        ''
      session:         sessionSetting(context.settings)
      recaptcha:       recaptcha
      passedCaptcha:   not recaptcha.enabled
      emailAsUsername: emailAsUsernameSetting(context.settings)

  render: ->
    <div>
      <Panel className="auth-panel" id="login-panel" header="Přihlášení" bsStyle="info">
        {@alert()}
        {@form()}
      </Panel>

      {@info()}

      {@additionalRender()}
    </div>

  additionalRender: -> null
  additionalInfo:   -> null

  alert: ->
    messages =
      'bad credentials': 'Špatné přihlašovací údaje'
      'user not activated': ('Účet není aktivován. Ve své emailové schránce najdete aktivační ' +
                             'email s odkazem, pomocí kterého dokončíte aktivaci účtu.')

    if @state.error
      <Alert id="login-alert" bsStyle="danger">{messages[@state.error] or @state.error}</Alert>

  form: ->
    <HorizontalForm>
      {@usernameFormGroup()}
      {@passwordFormGroup()}
      {@recaptcha()}
      {@submitButton()}
    </HorizontalForm>

  usernameFormGroup: ->
    <HorizontalForm.Group id='username' label={@usernameLabel()}>
      {@usernameControl()}
    </HorizontalForm.Group>

  usernameLabel: ->
    if @state.emailAsUsername.always then 'Registrovaný email' else 'Přihlašovací jméno'

  usernameControl: ->
    <FormControl {...@usernameControlProps()} />

  usernameControlProps: ->
    id:         'username-input'
    type:       'text'
    value:      @state.username
    autoFocus:  true
    onChange:   (e) => @setState(username: e.target.value)
    onKeyPress: (e) => @submit() if e.key == 'Enter'

  passwordFormGroup: ->
    <HorizontalForm.Control {...@passwordControlProps()} />

  passwordControlProps: ->
    id:         'password'
    type:       'password'
    label:      'Heslo'
    value:      @state.password
    onChange:   (value) => @setState(password: value)
    onKeyPress: (e) => @submit() if e.key == 'Enter'

  recaptcha: ->
    if @state.recaptcha.enabled
      <HorizontalForm.Offset id='recaptcha'>
        <Recaptcha siteKey={@state.recaptcha.siteKey}
         onVerify={(token) => @setState(passedCaptcha: true) if token}
         onExpire={=> @setState(passedCaptcha: false)}/>
      </HorizontalForm.Offset>

  submitButton: ->
    <HorizontalForm.Button id='login-submit' caption='Přihlásit' bsStyle="primary"
                           onClick={@submit} disabled={!@isValid()} />

  info: ->
    <Alert className="auth-alert">
      <p>
        Zapomněli jste heslo?&ensp;<InitPasswordResetLink>Resetujte si ho</InitPasswordResetLink>
      </p>

      <p>
        Nedostali jste aktivační email?&ensp;
        <ResendActivationEmailLink>Poslat znovu</ResendActivationEmailLink>
      </p>

      {@additionalInfo()}
    </Alert>

  isValid: ->
    @state.passedCaptcha and @isUsernameValid() and @state.password.length

  isUsernameValid: ->
    @state.username.length

  submit: =>
    @logIn()
      .then (response) =>
        @props.history.push('/')
        null # otherwise runaway promise
      .catch ForbiddenError, (error) =>
        @setState(error: error.data.detail)

  logIn: ->
    @context.auth.logIn(@state.username, @state.password)

export default withRouter(Login)
